import { render, staticRenderFns } from "./Activations.vue?vue&type=template&id=25a12064"
import script from "./Activations.vue?vue&type=script&lang=js"
export * from "./Activations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports